import {Controller} from "stimulus"

export default class extends Controller {
    static targets = [
        "summaryButton", "summaryText", "dropdown",
        "adultsInput", "childrenInput", "roomsInput", "petsCheckbox"
    ]

    connect() {
        this.updateSummary()
    }

    toggleDropdown() {
        this.dropdownTarget.style.display =
            this.dropdownTarget.style.display === "none" ? "block" : "none"
    }

    increment(event) {
        const type = event.currentTarget.dataset.type
        const input = this[`${type}InputTarget`]

        if (input.value === '6' && type === 'rooms') {
            return
        }

        input.value = parseInt(input.value) + 1
        this.updateSummary()
    }

    decrement(event) {
        const type = event.currentTarget.dataset.type
        const input = this[`${type}InputTarget`]
        const min = type === "children" ? 0 : 1
        if (parseInt(input.value) > min) {
            input.value = parseInt(input.value) - 1
            this.updateSummary()
        }
    }

    apply() {
        this.updateSummary()
        this.dropdownTarget.style.display = "none"

        this.emitGuestsData() // 🔥 aquí centralizamos el evento
    }

    updateSummary() {
        const adults = parseInt(this.adultsInputTarget.value)
        const children = parseInt(this.childrenInputTarget.value)
        const rooms = parseInt(this.roomsInputTarget.value)

        const totalGuests = adults + children
        this.summaryTextTarget.textContent = `${totalGuests} huésped${totalGuests !== 1 ? 'es' : ''} - ${rooms} ${rooms !== 1 ? 'habitaciones' : 'habitación'}`
    }

    // ✅ Nueva función: emite evento compatible con hotel_search_controller
    emitGuestsData() {
        const guests = {
            adults: parseInt(this.adultsInputTarget.value),
            children: parseInt(this.childrenInputTarget.value),
            rooms: parseInt(this.roomsInputTarget.value),
            pets: this.petsCheckboxTarget.checked ? 1 : 0
        }

        window.dispatchEvent(new CustomEvent("guests:update", {detail: {guests}}))
    }
}
